const types =  {
    SET_INPUT_VALUE: 'SET_INPUT_VALUE',
    RESET_PEOPLE_INVOICE_VALUES: 'RESET_PEOPLE_INVOICE_VALUES',
}

export default types;
